import DeleteIcon from '@mui/icons-material/Delete';
// import { useForm } from 'react-hook-form';
import { a11yProps, EstadoFactibilidadCorporativaENUM, generateUUID, gridSizeConst10, gridSizeMdLg11, ROUTER_PATHS, useTabsFormOnly } from '@/shared';
import {
  CustomSelectTextFieldNoForm,
  CustomTabPanel,
  FormTabsOnly,
  SampleCheckboxNoForm,
  SampleTable,
  SingleButton,
  TabsFormBoxScene,
} from '@/shared/components/ui';
import { AlertSeverityEnum, IncrementosInterface, IncrementosEnumChoices, type Cliente, type Contrato, type IDataPreventa,  type IVA, MaterialTransferido, CategoriaFCorporativaEnum } from '@/shared/interfaces';
import { MaterialesKey, useMaterialesUtilizadosStore } from '@/store/erp';
import { Button, Grid, Tab, TextField, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { TotalValoresProductosGrid } from '@/erp/clientes/fibra-optica/shared/components/form/rubros';
// import { useFetchContratos } from '@/shared/actions/erp';
// import { useForm } from 'react-hook-form';
// import ProductoLibrePopover from '../shared/ProductoLibrePopover';
// import { useFetchGetByIdfactibilidadCorporativos } from '@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions';
import { useNavigate } from 'react-router-dom';
import { useIvaStore } from '@/store/erp/shared/iva.store';
import AgregarProductoModal from '../shared/AgregarProductoModal';
import AgregarCostoModal from '../shared/AgregarCostoModal';
import { useFetchPutFactibilidadCorporativo } from '@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions';
import { useUiStore } from '@/store/ui';
import { usePlanStore } from '@/store/erp/system-settings/plan.store';
import { IFactibilidadCorporativo } from '@/shared/interfaces/erp/factibilidad_corporativo';
// import { Edit } from '@mui/icons-material';
// import useBackDetection from '@/erp/operaciones/preagendamiento/shared/hooks/useBackDetection';
// import ClientesFibraFormTabsOnly from '../ClientesFibraFormTabsOnly';
// import ClienteFibraFormTitle from './ClienteFibraFormTitle';
// import ClienteFibraServiceFormTab from './ClienteFibraServiceFormTab';
// import ClienteFibraSummaryTFormab from './ClienteFibraSummaryTFormab';
// import { ClienteFibraDocsFormTab } from './docs';
// import { ClienteFibraPlantillaFormTab } from './plantilla';
// import { ClienteFibraPromocionesFormTab } from './promociones';
// // import { ClienteFibraRubrosFormTab } from './rubros';
// import { ClienteFibraSurveyFormTab } from './survey';
// import TrazabilidadLogFormTab from './trazabilidad-log/TrazabailidadLogFormTab';

export type SaveContractFibraProps = {
  contract: Contrato;
};

export type MaterialTransferidoContabilidad = Partial<MaterialTransferido> & {
  codigo?: string;
  nombre?: string;
  precioUnitario?: number;
  cantidad?: number;
  total?: number;
  ivaValue?: number;
  ivaCode?: string;
  incremento?: number;
  incrementoName?: string;
  incrementoCodigo?: string;
  precioLibre?: boolean;
  preciosDisponibles?: IPreciosProductos[];
}


export type MaterialTransferidoInventarioCorporativo = Partial<MaterialTransferido> & {
  codigo?: string;
  nombre?: string;
  precioUnitario?: number;
  cantidad?: number;
  total?: number;
  ivaValue?: number;
  ivaCode?: string;
  incremento?: number;
  incrementoName?: string;
  incrementoCodigo?: string;
  precioLibre?: boolean;
  preciosDisponibles?: IPreciosProductos[];
}


export type ClienteFibraSummaryFormType = Contrato &
  Cliente &
  IDataPreventa & {
    planLabel: string;
    permanencia: string;
    numero_contrato: string; // num ref contrato
  };

export interface ClientesCorporativosSaveInterface {
  factCoorporativaData?: IFactibilidadCorporativo;
}

interface IPreciosProductos {
  estado: boolean;
  nombre: string;
  precio: number;
}



const ClientesCorporativosSave: React.FC<ClientesCorporativosSaveInterface> = ({
  factCoorporativaData
}) => {
  const returnUrl = ROUTER_PATHS.contabilidad.clientesCoorporativosNav;

  // const { id } = useParams();

  const [openModalAgregarProducto, setOpenModalAgregarProducto] = useState(false);
  const [openModalCosto, setOpenModalCosto] = useState(false);
  const [valoresServiciosAdicionalesCorporativos, setValoresServiciosAdicionalesCorporativos] = useState<MaterialTransferidoContabilidad[]>([]);
  const [valoresPlanesCorporativos, setValoresPlanesCorporativos] = useState<MaterialTransferidoContabilidad[]>([]);
  // const formRevisionDeValores = useForm({
  // });
  const navigate = useNavigate()

  // const IVA_VALUE = 0;

  // const {data:factCoorporativaData} = useFetchGetByIdfactibilidadCorporativos(id!)



  // const productosMockup: MaterialTransferidoContabilidad[] = [
  //   {
  //     codigo: '001',
  //     nombre: 'Camiseta Algodón',
  //     precioUnitario: 10.00,
  //     cantidad: 5,
  //     total: 50.00,
  //     ivaValue: 7.50, // 15% de 50
  //   },
  //   {
  //     codigo: '002',
  //     nombre: 'Zapatos Deportivos',
  //     precioUnitario: 45.00,
  //     cantidad: 2,
  //     total: 90.00,
  //     ivaValue: 13.50, // 15% de 90
  //   },
  // ]

  ///* hooks -------------------------
  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 1,
  });

  const ivas = useIvaStore(s => s.ivas);
  const setAlert = useUiStore(s => s.setAlert);

  const updateSelectedItemQuantity = useMaterialesUtilizadosStore(
    s => s.updateSelectedItemQuantity
  );
  const removeSelectedItem = useMaterialesUtilizadosStore(
    s => s.removeSelectedItem
  );
  const clearSelectedItems = useMaterialesUtilizadosStore(
    s => s.clearSelectedItems
  );

  const selectedItems: MaterialTransferidoContabilidad[] =
    useMaterialesUtilizadosStore(s => s.selectedItems);

  const addSelectedItem = useMaterialesUtilizadosStore(
    s => s.addSelectedItemCustomKey
  );

  const planesCorporativosGlobal = usePlanStore(s => s.plansCorporativos);
  // addSelectedItem(productosMockup)

  const { mutateAsync: fetchPutFactCorporativa } = useFetchPutFactibilidadCorporativo({
    navigate,
    returnUrl: returnUrl
  })


  const onSave = () => {
    // console.log({selectedItems})
    factCoorporativaData!.detalles = selectedItems as any
    factCoorporativaData!.productos_costeados = selectedItems.concat(valoresServiciosAdicionalesCorporativos).concat(valoresPlanesCorporativos)
    // console.log({factCoorporativaData})
    fetchPutFactCorporativa(factCoorporativaData!)
    setAlert(
      true,
      'Cambios guardados',
      AlertSeverityEnum.success
    );
  }

  const onApprove = () => {

    factCoorporativaData!.estado_factibilidad = EstadoFactibilidadCorporativaENUM.EN_GESTION
    factCoorporativaData!.revisado_contabilidad = true
    factCoorporativaData!.detalles = selectedItems as any
    factCoorporativaData!.productos_costeados = selectedItems.concat(valoresServiciosAdicionalesCorporativos).concat(valoresPlanesCorporativos)
    fetchPutFactCorporativa(factCoorporativaData!)

    setAlert(
      true,
      'Cotización enviada a supervisor',
      AlertSeverityEnum.success
    );

  }



  const calcTotalLine = (item: MaterialTransferidoContabilidad): string => {
    return (
      (
        +(item.precioUnitario || 0) *
        +(item.cantidad || 0) *
        (+(item.incremento || 0) / 100 + 1) *
        (+((item.ivaValue) || 0) / 100 + 1)
      ).toFixed(2) || ''
    );
  };

  const calcSubTotalLine = (item: MaterialTransferidoContabilidad): string => {
    return (
      (
        +(item.precioUnitario || 0) *
        +(item.cantidad || 0)
      ).toFixed(2) || ''
    );
  };


  const onChangeName = useCallback(
    (value: string, item: MaterialTransferidoContabilidad) => {
      updateSelectedItemQuantity(
        {
          ...item,
          nombre: value,
        },
        MaterialesKey.selectedItems,
        "codigo"
      );
    },
    [updateSelectedItemQuantity]
  );


  const onChangePrice = useCallback(
    (value: string, item: MaterialTransferidoContabilidad) => {
      console.log({ value, item })
      updateSelectedItemQuantity(
        {
          ...item,
          precioUnitario: value,

          total: calcTotalLine({
            ...item,
            precioUnitario: +value,
          }),
          subtotal: calcSubTotalLine({
            ...item,
            precioUnitario: +value,
          })
        },
        MaterialesKey.selectedItems,
        "codigo"
      );
    },
    [updateSelectedItemQuantity]
  );

  // const onChangeQuantity = useCallback(
  //   (value: number, item: MaterialTransferidoContabilidad) => {

  //     updateSelectedItemQuantity(
  //       {
  //         ...item,
  //         cantidad: +value,
  //         total: calcTotalLine({
  //           ...item,
  //           cantidad: +value,
  //         }),
  //       },
  //       MaterialesKey.selectedItems,
  //       "codigo"
  //     );
  //   },
  //   [updateSelectedItemQuantity]
  // );


  //calcular valores
  const calcTotal = (): string => {


    const allItems = selectedItems.concat(valoresServiciosAdicionalesCorporativos).concat(valoresPlanesCorporativos)
    return allItems
      .reduce(
        (acc, item) =>
          acc +
          +(item.precioUnitario || 0) *
          +(item.cantidad || 0) *
          (+(item.incremento || 0) / 100 + 1) *
          (+(item.ivaValue || 0) / 100 + 1),
        0
      )
      .toFixed(2);
  };

  const calcSubTotal = (): string => {
    // return selectedItems
    //   .reduce(
    //     (acc, item) =>
    //       acc + (item.precioUnitario || 0) * (item.cantidad || 0),
    //     0
    //   )
    //   .toFixed(2);
    const costoMaterialesEquipos = selectedItems
      .reduce(
        (acc, item) =>
          acc + (item.precioUnitario || 0) * (item.cantidad || 0) * (+(item.incremento || 0) / 100 + 1),
        0
      )
      .toFixed(2);

    const costoServiciosAdicionalesCorporativo = valoresServiciosAdicionalesCorporativos
      .reduce(
        (acc, item) =>
          acc + (item.precioUnitario || 0) * (item.cantidad || 0),
        0
      )
      .toFixed(2);

    const costoPlanCorporativo = valoresPlanesCorporativos
      .reduce(
        (acc, item) =>
          acc + (item.precioUnitario || 0) * (item.cantidad || 0),
        0
      )
      .toFixed(2);

    console.log({ costoPlanCorporativo })

    return (parseFloat(costoMaterialesEquipos) + parseFloat(costoPlanCorporativo) + parseFloat(costoServiciosAdicionalesCorporativo)).toString()
  };

  const calcTotalTaxes = (): string => {
    const allItems = selectedItems.concat(valoresServiciosAdicionalesCorporativos).concat(valoresPlanesCorporativos)
    return allItems
      .reduce(
        (acc, item) =>
          acc +
          +(item.precioUnitario || 0) *
          +(item.cantidad || 0) *
          (+(item.ivaValue || 0) / 100),
        0
      )
      .toFixed(2);
  };




  const onChangeIncremento = useCallback(
    (incremento: number, item: MaterialTransferidoContabilidad) => {
      const objIncremento = IncrementosEnumChoices.find(x => x.valor == incremento)
      updateSelectedItemQuantity(
        {
          ...item,
          incremento: incremento,
          incrementoName: objIncremento?.nombre,
          incrementoCodigo: objIncremento?.codigo,

          total: calcTotalLine({
            ...item,
            incremento: incremento,
          }),
        },
        MaterialesKey.selectedItems,
        "codigo"
      );
    },
    [updateSelectedItemQuantity]
  );
  const onChangeImpuesto = useCallback(
    (iva: IVA, item: MaterialTransferidoContabilidad) => {
      updateSelectedItemQuantity(
        {
          ...item,
          ivaCode: iva.codigo,
          ivaValue: +(iva?.porcentaje || 0) || 0,

          total: calcTotalLine({
            ...item,
            ivaCode: iva.codigo,
            ivaValue: +(iva?.porcentaje || 0) || 0,
          }),
        },
        MaterialesKey.selectedItems,
        "codigo"
      );
    },
    [updateSelectedItemQuantity]
  );




  const onChangePrecioLibre = useCallback(
    (value: boolean, item: MaterialTransferidoContabilidad) => {
      updateSelectedItemQuantity(
        {
          ...item,
          precioLibre: value,
        },
        MaterialesKey.selectedItems,
        "codigo"
      );
    },
    [updateSelectedItemQuantity]
  );

  const handleKeyDown = (e: any) => {
    const key = e.key;
    // Bloquea la tecla de guion, letras y teclas especiales
    if ((key === '-' || key === 'e' || /[^0-9]/.test(key)) && !['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Tab'].includes(e.key)) {
      e.preventDefault();  // Evita que se ingrese la tecla no permitida
    }
  }


  const onAddEmptyLine = () => {
    const uuid = generateUUID();
    const newLine = {
      codigo: uuid,
      nombre: "",
      precioUnitario: "0.00",
      cantidad: 0,
      total: 0,
      subtotal: 0,
      ivaCode: "IVA 0%",
      ivaValue: 0, // 15% de 50
      precioLibre: true,
      preciosDisponibles: [],
      categoria_fcorporativa: CategoriaFCorporativaEnum.MATERIALESEQUIPOS,
    }

    addSelectedItem(newLine, MaterialesKey.selectedItems, 'codigo', false, true);

  };






  useEffect(() => {
    clearSelectedItems(MaterialesKey.selectedItems)
    if (!Array.isArray(factCoorporativaData?.detalles))
      return
    factCoorporativaData?.detalles?.forEach(element => {
      const precioUnitarioAux = element?.producto_data?.precios?.at(0)?.precio || 0;
      addSelectedItem(
        {
          id: element.id || element.codigo,
          codigo: element.codigo || element.id,
          nombre: element?.producto_data?.descripcion || element?.nombre,
          precioUnitario: element.precioUnitario || precioUnitarioAux,
          cantidad: element.cantidad!,
          total: element.total || element.cantidad! * +precioUnitarioAux,
          subtotal: element.subtotal || element.cantidad! * +precioUnitarioAux,
          ivaCode: element.ivaCode || "IVA 0%",
          ivaValue: element.ivaValue || 0, // 15% de 50
          incremento: element.incremento,
          incrementoCodigo: element.incrementoCodigo,
          precioLibre: element.precioLibre || true,
          preciosDisponibles: element.preciosDisponibles || element?.producto_data?.precios,
          existe: element.existe,
          producto_data:element.producto_data,
          // incremento:,
          categoria_fcorporativa: element.categoria_fcorporativa || CategoriaFCorporativaEnum.MATERIALESEQUIPOS,
        },
        MaterialesKey.selectedItems, 'codigo', false, false
      );
    });
    // console.log({selectedItems})




    //VALORES DE PLAN
    const planChoosed = planesCorporativosGlobal.filter(x => x.codigo == factCoorporativaData?.preventa_corporativa_data?.plan)
    console.log({ planChoosed })
    //Se añadenValores de Plan
    if (planChoosed.length > 0) {

      const ValoresPlan: MaterialTransferidoContabilidad[] = []
      ValoresPlan.push({
        codigo: factCoorporativaData?.preventa_corporativa_data?.plan!,
        nombre: planChoosed[0].nombre || "PLAN DE PRUEBA",
        precioUnitario: planChoosed[0].valor,
        cantidad: 1,
        total: planChoosed[0].valor,
        subtotal: planChoosed[0].valor,
        ivaValue: 0,
        ivaCode: "",
        categoria_fcorporativa: CategoriaFCorporativaEnum.VALORESPLAN,
      })
      ValoresPlan.push({
        codigo: factCoorporativaData?.preventa_corporativa_data?.plan + "-instalacion",
        nombre: "VALOR DE INSTALACIÓN",
        precioUnitario: factCoorporativaData.preventa_corporativa_data?.valor_instalacion,
        cantidad: 1,
        total: factCoorporativaData.preventa_corporativa_data?.valor_instalacion,
        subtotal: factCoorporativaData.preventa_corporativa_data?.valor_instalacion,
        ivaValue: 0,
        ivaCode: "",
        categoria_fcorporativa: CategoriaFCorporativaEnum.VALORESPLAN,
      })
      console.log({ ValoresPlan })
      setValoresPlanesCorporativos(ValoresPlan)
    }


    //añadir validacion para servicios que vayan a manejar valores
    const ValoresServiciosAdicionales: MaterialTransferidoContabilidad[] = []
    if (factCoorporativaData?.preventa_corporativa_data?.seguridad_perimetral) {
      ValoresServiciosAdicionales.push({
        codigo: "SEGURIDAD_PERIMETRAL",
        nombre: "SEGURIDAD PERIMETRAL",
        precioUnitario: factCoorporativaData.preventa_corporativa_data?.costo_seguridad_perimetral,
        cantidad: 1,
        total: factCoorporativaData.preventa_corporativa_data?.costo_seguridad_perimetral,
        subtotal: factCoorporativaData.preventa_corporativa_data?.costo_seguridad_perimetral,
        ivaValue: 0,
        ivaCode: "",
        categoria_fcorporativa: CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
      })
    }
    if (factCoorporativaData?.preventa_corporativa_data?.fibra_oscura) {
      ValoresServiciosAdicionales.push({
        id: generateUUID(),
        codigo: "FIBRA_OSCURA",
        nombre: "FIBRA OSCURA",
        precioUnitario: factCoorporativaData?.preventa_corporativa_data?.costo_fibra_oscura,
        cantidad: 1,
        total: factCoorporativaData?.preventa_corporativa_data?.costo_fibra_oscura,
        series: [],
        contiene_serie: false,
        categoria_fcorporativa: CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
        producto_data: null,
      })
    }
    if (factCoorporativaData?.preventa_corporativa_data?.wifi_gestionado) {
      ValoresServiciosAdicionales.push({
        codigo: "WIFI_GESTIONADO",
        nombre: "WIFI GESTIONADO",
        precioUnitario: factCoorporativaData.preventa_corporativa_data?.costo_wifi_gestionado,
        cantidad: 1,
        total: factCoorporativaData.preventa_corporativa_data?.costo_wifi_gestionado,
        subtotal: factCoorporativaData.preventa_corporativa_data?.costo_wifi_gestionado,
        ivaValue: 0,
        ivaCode: "",
        categoria_fcorporativa: CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
      })
    }
    if (factCoorporativaData?.preventa_corporativa_data?.cableado_interno) {
      ValoresServiciosAdicionales.push({
        codigo: "CABLEADO_INTERNO",
        nombre: "CABLEADO INTERNO",
        precioUnitario: factCoorporativaData.preventa_corporativa_data?.costo_cableado_interno,
        cantidad: 1,
        total: factCoorporativaData.preventa_corporativa_data?.costo_cableado_interno,
        subtotal: factCoorporativaData.preventa_corporativa_data?.costo_cableado_interno,
        ivaValue: 0,
        ivaCode: "",
        categoria_fcorporativa: CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
      })
    }
    if (factCoorporativaData?.preventa_corporativa_data?.equipos_adicionales &&
      factCoorporativaData?.preventa_corporativa_data?.equipos_adicionales?.length > 0
    ) {
      factCoorporativaData?.preventa_corporativa_data?.equipos_adicionales?.map((x) => {
        ValoresServiciosAdicionales.push({
          codigo: x.codigo,
          nombre: x.producto_data?.descripcion + " " + x.codigo,
          precioUnitario: parseFloat(x.producto_data?.precios?.[0]?.precio || "0"),
          cantidad: 1,
          total: parseFloat(x.producto_data?.precios?.[0]?.precio || "0"),
          subtotal: parseFloat(x.producto_data?.precios?.[0]?.precio || "0"),
          ivaValue: 0,
          ivaCode: "",
          producto_data: x.producto_data,
          categoria_fcorporativa: CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
        })
      })
    }
    setValoresServiciosAdicionalesCorporativos(ValoresServiciosAdicionales)



  }, [factCoorporativaData]);

  // useBackDetection(clearSelectedItems,MaterialesKey.selectedItems)





  const columnsRevisionProductosContabilidad = useMemo<
    MRT_ColumnDef<MaterialTransferidoContabilidad>[]
  >(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Código',
        size: 120,
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 400,
        Cell: ({ row }) => {
          return (
            <TextField
              variant="outlined"
              value={row.original?.producto_data?.descripcion || row.original?.nombre}
              onChange={e => {
                // const regex = /^\d*\.?\d{0,2}$/;
                let value = e.target.value;

                // if (regex.test(value)) {
                // }
                onChangeName(value, row.original);
              }}
              fullWidth={true}
              type="text"
            />
          );
        },
      },
      {
        accessorKey: 'precioUnitario',
        header: 'Precio',
        size: 220,
        Cell: ({ row }) => {

          return (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={5} alignContent={"center"}>
                <SampleCheckboxNoForm
                  label="Editar"
                  labelPlacement='bottom'
                  defaultValue={row.original?.precioLibre}
                  onChangeValue={(value) => {
                    onChangePrecioLibre(value!, row.original);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                {
                  row.original?.precioLibre ?
                    <TextField
                      variant="outlined"
                      value={row.original.precioUnitario}
                      onChange={e => {
                        const regex = /^\d*\.?\d{0,2}$/;
                        let value = e.target.value;

                        if (regex.test(value)) {
                          onChangePrice(value, row.original);
                        }
                      }}
                      onKeyDown={handleKeyDown}
                      type="number"
                      inputProps={{ step: 0.01 }}
                    />
                    :
                    <>
                      <CustomSelectTextFieldNoForm<IPreciosProductos>
                        options={row.original?.preciosDisponibles?.filter(x => x.estado == true) || []}
                        menuItemKey="precio"
                        valueKey="precio"
                        labelKey="precio"
                        defaultValue={row.original?.precioUnitario || ''}
                        onChangeValue={value => {
                          onChangePrice(value, row.original);
                        }}
                        size={gridSizeConst10}
                      />
                    </>
                }
              </Grid>
            </Grid>
          );
        },
      },

      {
        accessorKey: 'incrementoCodigo',
        header: 'Incremento',
        size: 100,
        Cell: ({ row }) => {
          return (
            <>
              <CustomSelectTextFieldNoForm<IncrementosInterface>
                options={IncrementosEnumChoices || []}
                menuItemKey="codigo"
                valueKey="valor"
                labelKey="nombre"
                defaultValue={row.original?.incremento!}
                onChangeValue={incrementoValue => {
                  onChangeIncremento(parseFloat(incrementoValue), row.original);
                }}
              />
            </>
          );
        },
      },

      {
        accessorKey: 'impuesto',
        header: 'Imp %',
        size: 100,
        Cell: ({ row }) => {
          return (
            <>
              <CustomSelectTextFieldNoForm<IVA>
                options={ivas || []}
                menuItemKey="codigo"
                valueKey="codigo"
                labelKey="porcentaje"
                defaultValue={row.original.ivaCode || ''}
                onChangeValue={ivaCode => {
                  const iva = ivas.find(iva => iva?.codigo === ivaCode);
                  if (!iva) return;

                  onChangeImpuesto(iva, row.original);
                }}
              />
            </>
          );
        },
      },

      {
        accessorKey: 'cantidad',
        header: 'Cantidad',
        size: 120,
        // Cell: ({ row }) => {
        //     return (
        //       <Grid item container xs={12} spacing={1} alignItems="center">
        //         <Grid item xs={10}>
        //           <TextField
        //             variant="outlined"
        //             value={row.original.cantidad || ''}
        //             onChange={e => {
        //               const intValue = Math.floor(parseInt(e.target.value, 10));

        //               onChangeQuantity(intValue, {
        //                 ...row.original,
        //                 codigo: row.original.codigo,
        //               });
        //             }}
        //             type="number"
        //             onKeyDown={handleKeyDown}
        //             inputProps={{ min: 1 }}
        //             // disabled={!canUpdateRubro}
        //           />
        //         </Grid>
        //       </Grid>
        //     );

        // },
      },

      {
        accessorKey: 'subtotal',
        header: 'Sub-Total',
        size: 120,
      },
      {
        accessorKey: 'total',
        header: 'Total',
        size: 120,
      },
      {
        accessorKey: 'valortotal',
        header: 'Eliminar',
        size: 60,
        Cell: ({ row }) => {
          return (
            <SingleButton
              newCustomButton
              iconButton
              color="error"
              startIcon={<DeleteIcon />}
              onClick={() => {
                removeSelectedItem(
                  row.original?.codigo!, // id actually exist in stored data
                  MaterialesKey.selectedItems,
                  "codigo"
                );
              }}
            />
          );
        },
      },
    ],
    []
  );

  //columnas planes
  const columnasNoModificables = useMemo<
    MRT_ColumnDef<MaterialTransferidoContabilidad>[]
  >(
    () => [
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },
      {
        accessorKey: 'precioUnitario',
        header: 'Precio',
        size: 120,
      },
      {
        accessorKey: 'cantidad',
        header: 'Cantidad',
        size: 120,
      },
      {
        accessorKey: 'subtotal',
        header: 'Sub-Total',
        size: 120,
      },
      {
        accessorKey: 'total',
        header: 'Total',
        size: 120,
      },
    ],
    []
  );




  return (
    <TabsFormBoxScene
      titlePage={``}
      titlePageNode={
        <Grid
          item
          xs={12}
          md={12}
          container
          justifyContent="flex-end"
          alignItems="flex-start"
        >
          <Grid item xs={12} md={12} sx={{ paddingBottom: "20px" }}>
            <Typography variant="h5">
              {`Revisión de Valores para cliente`}
            </Typography>
            <Typography variant="h3">
              {`${factCoorporativaData?.prospecto_corporativo_data?.razon_social}`}
            </Typography>
          </Grid>
          <Button
            onClick={() => {
              setTimeout(() => {
                navigate(returnUrl)
              }, 200);
            }}
            variant="outlined"
            sx={{
              py: 1,
              my: "2px",
              marginX: 1
            }}
            size="small"
          >
            Regresar
          </Button>
          <Button
            onClick={() => {
              onSave();
              // navigate(returnUrl)
            }}
            color={"success"}
            variant="outlined"
            sx={{
              py: 1,
              my: "2px",
              marginX: 1
            }}
            size="small"
          >
            Guardar
          </Button>
          {
            factCoorporativaData?.estado_factibilidad !== EstadoFactibilidadCorporativaENUM.APROBADO 
            && !factCoorporativaData?.revisado_contabilidad
            ?
              <Button
                onClick={() => {
                  onApprove();
                  // navigate(returnUrl)
                }}
                color={"success"}
                variant="contained"
                sx={{
                  py: 1,
                  my: "2px",
                  marginX: 1
                }}
                size="small"
              >
                Enviar Cotización
              </Button>
              : null
          }
        </Grid>
      }
      // size={gridSizeMdLg10} // actual form container size
      showBtns={false}
      // // custom btns
      size={gridSizeMdLg11}
      showCustomBtns
      /* customBtns={
        <Grid container justifyContent="flex-start" mt={5}>
          <SingleButton
            variant="text"
            label="Regresar"
            onClick={() => {
              navigate(clientesFibraOpticaReturnUrl);
            }}
          />
        </Grid>
      } */
      // // tabs
      tabs={
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="RESUMEN" value={1} {...a11yProps(1)} />
        </FormTabsOnly>
      }
    >
      {/* =================== summary =================== */}
      <CustomTabPanel index={valueTab} value={1}>
        <Grid container spacing={3} mb={1}>
          {/* ================== button popover ================== */}
          {/* <ClienteRubroLibrePopover contract={contract} form={form} /> */}

          {/* ================== items table ================== */}
          <Grid item xs={12}>
            {/* <ProductoLibrePopover form={formRevisionDeValores} />
             */}
            <Grid container sm={12} justifyContent="flex-end" py={2} gap={1}>
              {/* -------- add line -------- */}
              <Grid item>
                <SingleButton
                  newCustomButton
                  justifyContent="flex-end"
                  label="AGREGAR LINEA"
                  variant="text"
                  onClick={onAddEmptyLine}
                />
              </Grid>

              {/* ----- add costo ----- */}
              <Grid item>
                <SingleButton
                  newCustomButton
                  justifyContent="flex-end"
                  label="AGREGAR COSTO"
                  variant="text"
                  onClick={() => {
                    setOpenModalCosto(true);
                  }}
                />
              </Grid>

              {/* ----- add product ----- */}
              <Grid item>
                <SingleButton
                  newCustomButton
                  justifyContent="flex-end"
                  label="AGREGAR PRODUCTO"
                  variant="text"
                  onClick={() => {
                    setOpenModalAgregarProducto(true);
                  }}
                />
              </Grid>

            </Grid>
            <SampleTable<MaterialTransferidoContabilidad>
              columns={columnsRevisionProductosContabilidad}
              data={selectedItems}
            />


            {/* ================== items servicios adicionales table ================== */}
            <Grid item xs={12}>
              <Typography variant="h6" p={2}>
                Servicios Adicionales
              </Typography>
              <SampleTable<MaterialTransferidoContabilidad>
                columns={columnasNoModificables}
                data={valoresServiciosAdicionalesCorporativos || []}
              // isLoading={isfcSolucionCosteada}
              />
            </Grid>

            {/* ================== items valores del plan table ================== */}
            <Grid item xs={12}>
              <Typography variant="h6" p={2}>
                Valores del Plan
              </Typography>
              <SampleTable<MaterialTransferidoContabilidad>
                columns={columnasNoModificables}
                data={valoresPlanesCorporativos || []}
              // isLoading={isfcSolucionCosteada}
              />
            </Grid>



          </Grid>

          {/* ================== total ================== */}
          <TotalValoresProductosGrid
            calcSubTotal={calcSubTotal}
            calcTotalTaxes={calcTotalTaxes}
            calcTotal={calcTotal}
          />
        </Grid>
        <AgregarProductoModal
          open={openModalAgregarProducto}
          onConfirm={() => setOpenModalAgregarProducto(false)}
          onClose={() => setOpenModalAgregarProducto(false)}
        />
        <AgregarCostoModal
          open={openModalCosto}
          onConfirm={() => setOpenModalCosto(false)}
          onClose={() => setOpenModalCosto(false)}
        />














      </CustomTabPanel>

    </TabsFormBoxScene>
  );
};

export default ClientesCorporativosSave;
